import { useEffect, useState } from 'react';

/**
 * True while the media query matches, updating as the window resizes or a
 * phone rotates.
 *
 * For layouts that must render DIFFERENT markup at different widths (a table
 * on a desktop, cards on a phone) rather than restyle the same markup — CSS
 * alone would keep both in the page, doubling every field.
 */
export function useMediaQuery(query: string): boolean {
  const get = () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : true);
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}

/** Tailwind's `md` breakpoint — tablets and up. */
export const useIsWide = () => useMediaQuery('(min-width: 768px)');
